const React = require('react');
const { createElement: h, useEffect, useRef, useState } = React;
const { joinWaitlist } = require('../lib/waitlistClient');
require('./LoginPage.css');

function Brand() {
  return h('div', { className: 'lp-brand' },
    h('svg', {
      width: 140, height: 34, viewBox: '0 0 128 30',
      fill: 'none', xmlns: 'http://www.w3.org/2000/svg', 'aria-label': 'AlleFlow'
    },
      h('rect', { x: 0, y: 3, width: 24, height: 24, rx: 6, fill: '#1a1f2e' }),
      h('circle', { cx: 8, cy: 15, r: 2.5, fill: 'white', fillOpacity: 0.9 }),
      h('line', { x1: 10.5, y1: 15, x2: 13.5, y2: 15, stroke: 'white', strokeWidth: 1.5, strokeOpacity: 0.65 }),
      h('path', { d: 'M13 12 L17 15 L13 18', stroke: 'white', strokeWidth: 1.5, strokeLinecap: 'round', strokeLinejoin: 'round' }),
      h('text', {
        x: 31, y: 21, fontFamily: 'Manrope, Segoe UI, sans-serif',
        fontSize: 17, fontWeight: 800, letterSpacing: -0.4, fill: '#1a1f2e'
      }, 'AlleFlow')
    )
  );
}

function WaitlistPage(props) {
  // Localized copy (en/da) is passed in from App via landingStrings.waitlist.
  var t = (props.strings && props.strings.waitlist) || {};
  var jobOptions = Array.isArray(t.jobs) ? t.jobs : [];

  var currentUser = props.currentUser || null;
  var prefillEmail = currentUser ? (currentUser.email || currentUser.username || '') : '';

  var [email, setEmail] = useState(String(prefillEmail || ''));
  var [name, setName] = useState('');
  var [company, setCompany] = useState('');
  var [job, setJob] = useState('');
  var [reason, setReason] = useState('');
  var [error, setError] = useState('');
  var [isSubmitting, setIsSubmitting] = useState(false);
  // Already-submitted users land straight on the "wait for the email" message.
  var [done, setDone] = useState(!!(currentUser && currentUser.waitlistSubmitted));
  var emailRef = useRef(null);

  // Focus the email field on mount (only while the form is showing).
  useEffect(function() {
    if (!done && emailRef.current) emailRef.current.focus();
  }, [done]);

  function submit(event) {
    event.preventDefault();
    setError('');
    setIsSubmitting(true);

    joinWaitlist({
      email: String(email || '').trim(),
      name: String(name || '').trim(),
      company: String(company || '').trim(),
      job: String(job || '').trim(),
      reason: String(reason || '').trim(),
      userId: currentUser && currentUser.id ? String(currentUser.id) : ''
    })
      .then(function() {
        setDone(true);
        // Persist the submitted flag onto currentUser so navigating away and back
        // keeps showing the "wait for the email" message (not the form again).
        if (typeof props.onSubmitted === 'function') props.onSubmitted();
      })
      .catch(function(err) {
        setError(err && err.message ? err.message : (t.error || 'Could not add you to the waitlist.'));
      })
      .finally(function() { setIsSubmitting(false); });
  }

  return h('main', { className: 'lp-root' },
    h('div', { className: 'lp-card lp-card--solo' },
      h('div', { className: 'lp-panel lp-panel--right' },
        h('div', { className: 'lp-form-wrap' },
          h(Brand),
          done
            ? h('div', { className: 'lp-form-intro' },
                h('h1', { className: 'lp-form-title' }, t.doneTitle),
                h('p', { className: 'lp-form-subtitle' }, t.doneSubtitle),
                h('button', {
                  className: 'lp-submit',
                  type: 'button',
                  onClick: function() { props.onNavigateTo('/'); }
                }, t.backHome)
              )
            : h('div', null,
                h('div', { className: 'lp-form-intro' },
                  h('h1', { className: 'lp-form-title' }, t.title),
                  h('p', { className: 'lp-form-subtitle' }, t.subtitle)
                ),
                h('form', { className: 'lp-form', onSubmit: submit },
                  h('div', { className: 'lp-field' },
                    h('label', { className: 'lp-label', htmlFor: 'wl-email' }, t.emailLabel),
                    h('input', {
                      id: 'wl-email', className: 'lp-input', type: 'email', ref: emailRef,
                      value: email, onChange: function(e) { setEmail(e.target.value); },
                      placeholder: t.emailPlaceholder, autoComplete: 'email', required: true
                    })
                  ),
                  h('div', { className: 'lp-field' },
                    h('label', { className: 'lp-label', htmlFor: 'wl-name' }, t.nameLabel),
                    h('input', {
                      id: 'wl-name', className: 'lp-input', type: 'text',
                      value: name, onChange: function(e) { setName(e.target.value); },
                      placeholder: t.namePlaceholder, autoComplete: 'name'
                    })
                  ),
                  h('div', { className: 'lp-field' },
                    h('label', { className: 'lp-label', htmlFor: 'wl-company' }, t.companyLabel),
                    h('input', {
                      id: 'wl-company', className: 'lp-input', type: 'text',
                      value: company, onChange: function(e) { setCompany(e.target.value); },
                      placeholder: t.companyPlaceholder, autoComplete: 'organization'
                    })
                  ),
                  h('div', { className: 'lp-field' },
                    h('label', { className: 'lp-label', htmlFor: 'wl-job' }, t.jobLabel),
                    h('select', {
                      id: 'wl-job', className: 'lp-input',
                      value: job, onChange: function(e) { setJob(e.target.value); }
                    },
                      [h('option', { key: '', value: '' }, t.jobPlaceholder)].concat(
                        jobOptions.map(function(opt) {
                          return h('option', { key: opt, value: opt }, opt);
                        })
                      )
                    )
                  ),
                  h('div', { className: 'lp-field' },
                    h('label', { className: 'lp-label', htmlFor: 'wl-reason' }, t.reasonLabel),
                    h('textarea', {
                      id: 'wl-reason', className: 'lp-input',
                      rows: 4, value: reason, onChange: function(e) { setReason(e.target.value); },
                      placeholder: t.reasonPlaceholder, required: true
                    })
                  ),
                  error ? h('p', { className: 'lp-error' }, error) : null,
                  h('button', { className: 'lp-submit', type: 'submit', disabled: isSubmitting },
                    isSubmitting ? t.submitting : t.submit
                  )
                )
              )
        )
      )
    )
  );
}

module.exports = WaitlistPage;
